import { useState } from "react";
import CampaignForm from "../../components/layouts/CampaignForm";
import Preview from "../../components/layouts/Preview";
import DashboardLayout from "../../components/layouts/DashboardLayout";
import { Link } from "react-router-dom";
import { LinkButton } from "../../components/ui/LinkButton";
import axios from "axios";
import { SERVER_URL } from "../../utils/config";
import { message } from "../../utils/toast";
import { ArrowLeft, Save } from "lucide-react";
import { Button } from "../../components/ui/Button";
import { Spinner } from "../../components/ui/Spinner";

const CampaignPage = () => {
  const [activeTab, setActiveTab] = useState("edit");
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    campaign_name: "",
    first_name: "",
    left_navigation: "",
    page_header_text: "",
    video_title: "",
    video_link: "",
    button_one_text: "",
    button_one_link: "",
    button_two_text: "",
    button_two_link: "",
    button_three_text: "",
    button_three_link: ""
  });

  const createCampaign = () => {
    setLoading(true);
    axios
      .post(`${SERVER_URL}/api/campaign`, formData)
      .then(({ data }) => {
        switch (data.message) {
          case "campagin_created":
            setFormData({
              campaign_name: "",
              left_navigation: "",
              page_header_text: "",
              video_title: "",
              video_link: "",
              button_one_text: "",
              button_one_link: "",
              button_two_text: "",
              button_two_link: "",
              button_three_text: "",
              button_three_link: ""
            });
            message({
              type: "success",
              content: "Campagin created successfully"
            });
            setLoading(false);
            break;

          default:
            break;
        }
      })
      .catch((error) => {
        setLoading(false);
        message({ type: "error", content: error.message });
      });
  };

  return (
    <DashboardLayout>
      <div className="flex-1 p-8">
        <div className="mb-8">
          <Link
            to="/campaigns-list"
            className="flex items-center gap-2 text-gray-600 hover:text-gray-900"
            onClick={() => {
              // Select Chatbot
              const widgetRoots = document.querySelectorAll(
                "#avachats-widget-root"
              );

              widgetRoots.forEach((widget, i) => {
                const shadowRoot = widget.shadowRoot;
                const avachatsWidget =
                  shadowRoot.querySelector(".avachats-widget");
                if (avachatsWidget !== null) {
                  avachatsWidget.remove();
                }
              });
            }}
          >
            <ArrowLeft size={20} />
            <span>Back to Campaigns</span>
          </Link>
          <h1 className="text-2xl font-bold flex justify-between text-gray-900 max-md:text-lg">
            <span>Campaign Editor</span>
            {activeTab === "preview" &&
              formData.button_three_text &&
              formData.button_three_text && (
                <LinkButton
                  onClick={() =>
                    window.open(formData.button_three_link, "_blank")
                  }
                  className="text-[1.2rem] float-right"
                >
                  {formData.button_three_text.includes("{{first_name}}")
                    ? formData.button_three_text.replace(
                        "{{first_name}}",
                        formData.lead_name.split(" ")[0]
                      )
                    : formData.button_three_text}
                </LinkButton>
              )}
          </h1>
          <p className="text-gray-600 flex justify-between">
            <span className="max-md:text-sm">
              Customize your landing page appearance
            </span>
          </p>
        </div>

        <div className="mb-6">
          <div className="border-b border-gray-200">
            <nav className="flex justify-between space-x-8 max-md:relative">
              <span className="space-x-8 max-md:mt-8">
                <button
                  onClick={() => {
                    setActiveTab("edit");

                    // Select Chatbot
                    const widgetRoots = document.querySelectorAll(
                      "#avachats-widget-root"
                    );

                    widgetRoots.forEach((widget, i) => {
                      const shadowRoot = widget.shadowRoot;
                      const avachatsWidget =
                        shadowRoot.querySelector(".avachats-widget");
                      if (avachatsWidget !== null) {
                        avachatsWidget.remove();
                      }
                    });
                  }}
                  className={`py-4 px-1 inline-flex items-center border-b-2 font-medium text-sm ${
                    activeTab === "edit"
                      ? "border-indigo-500 text-indigo-600"
                      : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                  }`}
                >
                  Edit
                </button>
                <button
                  onClick={() => setActiveTab("preview")}
                  className={`py-4 px-1 inline-flex items-center border-b-2 font-medium text-sm ${
                    activeTab === "preview"
                      ? "border-indigo-500 text-indigo-600"
                      : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                  }`}
                >
                  Preview
                </button>
              </span>
              {activeTab === "edit" && (
                <Button
                  onClick={createCampaign}
                  className={
                    "inline-flex items-center h-10 gap-2 text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors max-md:-mt-4 max-md:absolute max-md:!ml-0 max-md:flex max-md:justify-center max-md:w-full"
                  }
                >
                  {loading ? (
                    <Spinner />
                  ) : (
                    <>
                      <Save size={20} />
                      Create Campaign
                    </>
                  )}
                </Button>
              )}
            </nav>
          </div>
        </div>

        <div
          className="overflow-y-auto"
          style={{
            height: window.innerHeight - (window.innerWidth <= 768 ? 300 : 255)
          }}
        >
          {activeTab === "edit" ? (
            <CampaignForm
              parentFormData={formData}
              onChangeValues={(formData) => setFormData(formData)}
              type={"campagin"}
            />
          ) : (
            <Preview type="campagin" formData={formData} />
          )}
        </div>
      </div>
    </DashboardLayout>
  );
};

export default CampaignPage;
